import React from "react";

const ResumenCliente = ({ payload }) => {
    // Combinar los datos del domicilio
    const domicilio = `${payload.nombre_calle}, ${payload.numero_exterior}, ${payload.colonia}, ${payload.codigo_postal}`;

    return (
        <div
            style={{
                marginBottom: "10px",
                marginLeft: "50px",
                padding: "10px",
                borderRadius: "5px",
                background: "#d90e75",
                color: "#fff",
                fontSize: "0.9rem",
            }}
        >
            <p>
                <strong>Nombre:</strong> {payload.nombre}
            </p>
            <p>
                <strong>Domicilio:</strong> {domicilio}
            </p>
            <p>
                <strong>Número telefónico:</strong> {payload.telefono}
            </p>
            <p>
                <strong>Correo electrónico:</strong> {payload.email}
            </p>
            <p>
                <strong>Paquete:</strong> {payload.paquete}
            </p>
            <p>
                <strong>CURP:</strong> {payload.curp}
            </p>
           
        </div>
    );
};

export default ResumenCliente;
